var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.canLoad
    ? _c(
        "div",
        { style: { width: "100%" } },
        [
          _vm.editors[_vm.sectionKey] &&
          _vm.editors[_vm.sectionKey].hasOwnProperty(_vm.id)
            ? [
                _c("div", {
                  class: _vm.getClassName,
                  attrs: { id: `custom-${_vm.sectionKey}-${_vm.id}` },
                  domProps: { innerHTML: _vm._s(_vm.getEditorContent) },
                }),
                _vm.canShowConditional
                  ? _vm._t("conditional-content")
                  : _vm._e(),
              ]
            : !_vm.isEmptyContent
            ? [
                _vm.textEditors &&
                _vm.textEditors[_vm.sectionKey] &&
                _vm.textEditors[_vm.sectionKey][_vm.id] &&
                _vm.textEditors[_vm.sectionKey][_vm.id].html
                  ? [
                      _c("div", {
                        class: _vm.getClassName,
                        attrs: { id: `custom-${_vm.sectionKey}-${_vm.id}` },
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.textEditors[_vm.sectionKey][_vm.id].html
                          ),
                        },
                      }),
                      _vm.canShowConditional
                        ? _vm._t("conditional-content")
                        : _vm._e(),
                    ]
                  : _vm.textEditors &&
                    _vm.textEditors[_vm.sectionKey] &&
                    _vm.textEditors[_vm.sectionKey][_vm.id] &&
                    _vm.textEditors[_vm.sectionKey][_vm.id].hasOwnProperty(
                      "html"
                    ) &&
                    _vm.textEditors[_vm.sectionKey][_vm.id].html !== null
                  ? [
                      _c("div", {
                        class: _vm.getClassName,
                        attrs: { id: `custom-${_vm.sectionKey}-${_vm.id}` },
                        domProps: {
                          innerHTML: _vm._s(
                            !_vm.live && !_vm.preview && !_vm.renderOnly
                              ? _vm.froalaDefaultContent
                              : ""
                          ),
                        },
                      }),
                      _vm.canShowConditional
                        ? _vm._t("conditional-content")
                        : _vm._e(),
                    ]
                  : [
                      _c(
                        "div",
                        {
                          class: _vm.getClassName,
                          attrs: { id: `custom-${_vm.sectionKey}-${_vm.id}` },
                        },
                        [_vm._t("default-content")],
                        2
                      ),
                      _vm._t("conditional-content"),
                    ],
              ]
            : [
                _c("div", {
                  class: _vm.getClassName,
                  attrs: { id: `custom-${_vm.sectionKey}-${_vm.id}` },
                  domProps: {
                    innerHTML: _vm._s(
                      !_vm.live && !_vm.preview && !_vm.renderOnly
                        ? _vm.froalaDefaultContent
                        : ""
                    ),
                  },
                }),
                _vm.canShowConditional
                  ? _vm._t("conditional-content")
                  : _vm._e(),
              ],
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }